import { parseISO } from 'date-fns'
import { PackageProps } from '../Packages/Package'

export interface PromotionProps {
  promotion_id: string;
  promotion_name: string;
  promotion_start_date: string;
  promotion_end_date: string;
  packages_in_promotion: PackageProps[];
}

export const isPromotionActive = (promotion: PromotionProps): boolean => {
    if (!promotion) return false
    
    const currentDate = new Date()

    const afterStart = promotion.promotion_start_date 
      ? currentDate >= parseISO(promotion.promotion_start_date) 
      : true
    
    const beforeEnd = promotion.promotion_end_date 
      ? currentDate <= parseISO(promotion.promotion_end_date) 
      : true
    
    return afterStart && beforeEnd
  }
